var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.636,
    height: 20.636,
    viewBox: "0 0 20.636 20.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_84f2d9c36c6f682a106822db86590265",
    "data-name": "84f2d9c36c6f682a106822db86590265",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    "data-name": "Caminho 557",
    d: "M27.884,30.636H23.757A2.752,2.752,0,0,1,21,27.884V23.757A2.752,2.752,0,0,1,23.757,21h4.127a2.752,2.752,0,0,1,2.752,2.752v4.127A2.752,2.752,0,0,1,27.884,30.636Zm1.377-8.254H22.382v6.879h6.879ZM27.884,19.63H23.757A2.752,2.752,0,0,1,21,16.877V12.75A2.754,2.754,0,0,1,23.757,10h4.127a2.752,2.752,0,0,1,2.752,2.752v4.127A2.751,2.751,0,0,1,27.884,19.63Zm1.377-8.254H22.382v6.879h6.879ZM16.879,30.636H12.752A2.752,2.752,0,0,1,10,27.884V23.757A2.752,2.752,0,0,1,12.752,21h4.127a2.752,2.752,0,0,1,2.752,2.752v4.127A2.754,2.754,0,0,1,16.879,30.636Zm1.375-8.254H11.375v6.879h6.879ZM16.879,19.63H12.752A2.751,2.751,0,0,1,10,16.879V12.752A2.752,2.752,0,0,1,12.752,10h4.127a2.752,2.752,0,0,1,2.752,2.752v4.127A2.754,2.754,0,0,1,16.879,19.63Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipos);
export default __webpack_public_path__ + "static/media/Tipos.8496cad131c3d9d99c0529467c08b7af.svg";
export { ForwardRef as ReactComponent };